import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calendar-page-content" }
const _hoisted_2 = { class: "calendar-page-week-view" }
const _hoisted_3 = { class: "fc-event-main-frame" }
const _hoisted_4 = { class: "fc-event-time" }
const _hoisted_5 = { class: "fc-event-title-container" }
const _hoisted_6 = { class: "fc-event-title fc-sticky" }

import { onMounted, ref, watch } from 'vue';
import FullCalendar from '@fullcalendar/vue3';
import { CalendarOptions, EventClickArg } from '@fullcalendar/core';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction';
import { useCalendarBulkAttendanceStore, useCalendarStore } from '@/store';
import CalendarBulkAttendance from './CalendarBulkAttendance.vue';
import { CALENDAR_COLOR, EMIT, PERMISSIONS } from '@/enum';
import { can, modifiedRRulePlugin, useDateTime } from '@/composables';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarWeek',
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;
const calendar = ref();
const calendarStore = useCalendarStore();
const calendarBulkAttendanceStore = useCalendarBulkAttendanceStore();
const today = new Date();

__expose({ calendar });

onMounted(() => {
  setCalendarEvents();
});

const setCalendarEvents = () => {
  calendarOptions.value.events = calendarStore.events ? calendarStore.events : [];
};

watch(() => calendarStore.events, setCalendarEvents);

const calendarOptions = ref<CalendarOptions>({
  plugins: [timeGridPlugin, interactionPlugin, modifiedRRulePlugin],
  initialView: 'timeGridWeek',
  headerToolbar: false,
  allDaySlot: false,
  dayHeaderFormat: { day: 'numeric' },
  dayHeaderContent: (arg) =>
    calendarBulkAttendanceStore.defineBulkAttendance(arg, can([PERMISSIONS.THERAPY_RESULTS_BULK_UPDATE])),
  weekends: true,
  nowIndicator: true,
  height: '100%',
  expandRows: true,
  eventClassNames: (arg) => calendarStore.defineEventsClassNames(arg),
  eventShortHeight: 36,
  eventBackgroundColor: CALENDAR_COLOR.EVENT_BACKGROUND_COLOR,
  eventBorderColor: CALENDAR_COLOR.EVENT_BORDER_COLOR,
  eventTextColor: CALENDAR_COLOR.EVENT_TEXT_COLOR,
  eventMinHeight: 24,
  events: [],
  navLinks: true,
  navLinkDayClick: function (date) {
    emit(EMIT.DAY_VIEW, date);
  },
  dateClick: function (info: DateClickArg) {
    emit(EMIT.NEW_EVENT, info);
  },
  eventClick: (info: EventClickArg) => {
    const isDocumented = info.event._def.extendedProps.eventStatus === 'documented';
    const isInPast = (info.event.start as Date) < new Date();
    const isCaseloadManagement = calendarStore.isCaseloadManagement(info.event._def.extendedProps.eventType);
    const showDocumentEvent = isDocumented || isInPast;
    const isCaseloadAndInCurrentMonth =
      isCaseloadManagement && useDateTime().isSameMonthAndYear(info.event.start as Date);

    if (showDocumentEvent && !isCaseloadAndInCurrentMonth) {
      emit(EMIT.DOCUMENT_EVENT, info);
    } else {
      emit(EMIT.EDIT_EVENT, info);
    }
  },
  scrollTime: '07:00:00',
  viewDidMount: () => emit(EMIT.MOUNTED, 'week'),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(can)([_unref(PERMISSIONS).THERAPY_RESULTS_BULK_UPDATE]) && _unref(calendarBulkAttendanceStore).displayBulkAttendance)
      ? (_openBlock(), _createBlock(CalendarBulkAttendance, {
          key: 0,
          onCancel: _unref(calendarBulkAttendanceStore).onBulkAttendanceCancel
        }, null, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(FullCalendar), {
        ref_key: "calendar",
        ref: calendar,
        options: calendarOptions.value,
        class: _normalizeClass('today-is-' + _unref(today).toLocaleDateString('en-us', { weekday: 'long' }))
      }, {
        eventContent: _withCtx((arg) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(useDateTime)().formatTimeByTimezone(arg.event.start, arg.event.extendedProps.hostTimezoneName)) + " - " + _toDisplayString(_unref(useDateTime)().formatTimeByTimezone(arg.event.end, arg.event.extendedProps.hostTimezoneName)) + " " + _toDisplayString(arg.event.extendedProps.hostTimezone), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(arg.event.title), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["options", "class"])
    ])
  ]))
}
}

})